import HomePage from "views/client/HomePage.js";
import ProductsPage from "views/client/ProductsPage.js";
import AboutPage from "views/client/AboutPage.js";
import ContactPage from "views/client/ContactPage.js";

var clientRoutes = [
  {
    path: "/",
    name: "Home",
    component: <HomePage />,
    layout: "",
  },
  {
    path: "/products",
    name: "Products",
    component: <ProductsPage />,
    layout: "",
  },
  {
    path: "/about",
    name: "About",
    component: <AboutPage />,
    layout: "",
  },
  {
    path: "/contact",
    name: "Contact",
    component: <ContactPage />,
    layout: "",
  },
];

export default clientRoutes;

